module.exports = __webpack_public_path__ + "media/images/svgs/logo-small-f5b6a363dada7cc18de48de069b3e1c2.svg";